import { httpsCallable } from 'firebase/functions';
import { functions } from '../../constants/firebaseModular';
import type { GetGoogleWalletPassPayload, GetGoogleWalletPassResponse } from '@usacsmideo/types';
import * as Sentry from '@sentry/browser';

export const getGoogleWalletPass = async (patientId: string): Promise<GetGoogleWalletPassResponse> => {
  const callable = httpsCallable<GetGoogleWalletPassPayload, GetGoogleWalletPassResponse>(
    functions,
    'getGoogleWalletPass',
  );
  try {
    const result = await callable({ patientId });
    return result.data;
  } catch (error: unknown) {
    Sentry.captureException(error, { tags: { function: 'getGoogleWalletPass' } });
    throw error;
  }
};
